export const config = {
  API_URL: window._env_.API_URL,
  DEVOPS_ORG_URL: window._env_.DEVOPS_ORG_URL,
  AUTH_AZUREAD_CLIENT_ID: window._env_.AUTH_AZUREAD_CLIENT_ID,
  AUTH_AZUREAD_AUTHORITY: window._env_.AUTH_AZUREAD_AUTHORITY,
  AUTH_AZUREAD_REDIRECT_URI: window._env_.AUTH_AZUREAD_REDIRECT_URL,
};
